

import {Component, Prop, Vue } from 'vue-property-decorator';
import { UserProfile } from '@api/models/UserProfile';

@Component({})
export default class TimeCardFooterBase extends Vue {
    @Prop() userProfiles: UserProfile[];
    @Prop({ default: "" }) buttonTitle: string;

    readonly base_class = "time-card-footer";
    readonly speakers_class = "time-card-footer__speakers";
    readonly actions_class = "time-card-footer__actions";

    stopPropagation(event: MouseEvent) {
        event.stopPropagation()
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }

    get isAdmin(): boolean {
      return this.$store.getters['isAdmin'];
    }
}

